import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import useForm from 'react-hook-form';
import { toast } from 'react-toastify';
import api from '../../config/axios';

import Breadcrumb from '../common/breadcrumb';
import { useStateValue } from '../../store';

const messageVariant = (name, repartidor) =>
    `Hola ${name}, soy ${repartidor} de Aguaman.\n\nLe dejo mi número para cuando necesite su botellón de agua. La entrega se hace en minutos, le llevamos uno lleno y nos da el vacío.\n\nSaludos!`;

const ClientInvitation = withRouter(() => {
    const [{ auth }] = useStateValue();
    const {
        handleSubmit: handleSubmitPush,
        register: registerPush,
        errors: errorsPush,
    } = useForm();

    const sendInvitation = async (data) => {
        const phoneParsed = data.phone.replace('0', '58');
        const nameParsed = auth.user.name.split(' ')[0];
        const messageText = messageVariant(
            data.name,
            nameParsed,
        );
        const waUrl = `https://wa.me/${phoneParsed}?text=${encodeURIComponent(messageText)}`;

        // Persistir el lead antes de abrir WhatsApp (U3)
        try {
            await api.post('/lead', {
                name: data.name,
                phone: data.phone,
                observation: data.observation || null,
            });
        } catch (err) {
            toast.error('No se pudo guardar el lead, pero se abrirá WhatsApp igual');
        }

        window.open(waUrl);
        return;
    };

    return (
        <Fragment>
            <Breadcrumb title="Invitar cliente" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <form
                                    onSubmit={handleSubmitPush(sendInvitation)}
                                    className="needs-validation user-add"
                                    noValidate=""
                                >
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">
                                            <span>*</span> Primer Nombre
                                        </label>
                                        <input
                                            className="form-control col-xl-4 col-md-7"
                                            type="text"
                                            name="name"
                                            ref={registerPush({
                                                required: true,
                                            })}
                                        />
                                        <p className="message-error-input">
                                            {errorsPush.name &&
                                                errorsPush.name.type === 'required' &&
                                                'Nombre obligatorio'}
                                        </p>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-xl-3 col-md-4">
                                            <span>*</span> Teléfono
                                        </label>
                                        <input
                                            className="form-control col-xl-5 col-md-7"
                                            type="tel"
                                            name="phone"
                                            ref={registerPush({
                                                required: true,
                                            })}
                                        />
                                        <p className="message-error-input">
                                            {errorsPush.phone &&
                                                errorsPush.phone.type === 'required' &&
                                                'Teléfono obligatorio'}
                                        </p>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-xl-3 col-md-4">
                                            Observación (ej: Cliente de la arboleda)
                                        </label>
                                        <input
                                            className="form-control col-xl-5 col-md-7"
                                            type="text"
                                            name="observation"
                                            ref={registerPush({})}
                                        />
                                    </div>
                                    <div className="col-sm-12 text-center mt-5 mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                            onClick={handleSubmitPush(sendInvitation)}
                                        >
                                            Enviar invitación
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default ClientInvitation;
